var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Flex, Box } from 'rebass';
import { Icon, Pill } from '../';
var QuickFilter = React.forwardRef(function (_a, ref) {
    var active = _a.active, label = _a.label, content = _a.content, onChange = _a.onChange, onClick = _a.onClick, permanent = _a.permanent, total = _a.total, _b = _a.bg, bg = _b === void 0 ? 'primary_2' : _b, _c = _a.color, color = _c === void 0 ? 'neutral_0' : _c, props = __rest(_a, ["active", "label", "content", "onChange", "onClick", "permanent", "total", "bg", "color"]);
    if (!permanent && !active && total === 0)
        return null;
    var labelText = "" + label + (total !== undefined ? " (" + total + ")" : '');
    var textContent = (React.createElement(Box, { flex: "1", style: { textOverflow: 'ellipsis', overflow: 'hidden' } },
        React.createElement("b", null, labelText),
        content && " " + content));
    return (React.createElement(Pill, __assign({ ref: ref, display: "inline-block", bg: active ? bg : 'transparent', color: active ? color : bg, maxWidth: "250px", borderColor: active ? 'transparent' : bg, borderWidth: "1px", borderStyle: "solid", fontWeight: "normal", onClick: function (event) {
            onChange && onChange(!active);
            onClick && onClick(event);
        } }, props),
        React.createElement(Flex, { alignItems: "center" },
            textContent,
            onChange && active && (React.createElement(Box, { ml: 2 },
                React.createElement(Icon, { icon: "times" }))))));
});
export default QuickFilter;
